// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"183d708e","458":"6a1138f2","774":"38359316","807":"eb34550e","820":"48b6aaa1","851":"917c6227","858":"00c4d1f4"}[chunkId] + ".chunk.js";
};